import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  Input,
  InputLabel,
  Select,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Tabs,
  TextField,
} from "@mui/material";
import { TabPanel } from "../../../../components/ui/TabPanel";
import { Form } from "react-router-dom";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { useEffect, useState } from "react";
import { useApi } from "../../../../services/HttpService";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";

export const EditAgreement = (props: { id: number; onSuccess: () => void }) => {
  const [acitveTab, setActiveTab] = useState(0);
  const { api, isLoading, error } = useApi();

  const [data, setData] = useState(null);

  const initData = { company: {}, agreement: {}, contact: {} };

  useEffect(() => {
    if (props.id) {
      fetch();
    } else {
      setData(initData);
      getCompanies();
    }
  }, []);

  const getCompanies = async () => {
    const res = await api("/manage/company/getCompany");
  };

  const fetch = async () => {
    const res = await api("/la-agreement/get?id=" + props.id, "GET", {});
    if (res && res.statusCode === 200) {
      setData(res.data);
    } else {
    }
  };
  const [formData, setFormData] = useState({});

  const update = async () => {
    const res = await api(
      "/la-agreement/update?id=" + props.id,
      "POST",
      formData
    );
    if (res && res.statusCode === 200) {
      props.onSuccess();
    } else {
    }
  };

  const create = async () => {
    const data = { ...formData, company: 1, contact: 1 };
    const res = await api("/la-agreement/create", "POST", data);
    if (res && res.statusCode === 200) {
      props.onSuccess();
    } else {
    }
  };

  const converDate = (v) => {
    if (!v) {
      return v;
    }
    return dayjs(v);
  };

  if (data === null) {
    return <CircularProgress />;
  }

  return (
    <div>
      <Tabs value={acitveTab} onChange={(e, v) => setActiveTab(v)}>
        <Tab label="Information" />
        <Tab label="Products" />
        <Tab label="Invoices" />
      </Tabs>
      <TabPanel index={0} value={acitveTab}>
        <Box sx={{ p: 4 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="no">
            <Grid>
              <Grid>
                <FormControl>
                  <InputLabel>Name</InputLabel>
                  <Input
                    defaultValue={data.agreement.name}
                    onChange={(e) =>
                      setFormData({ ...formData, name: e.target.value })
                    }
                  />
                </FormControl>
              </Grid>
              <Grid>
                <FormControl>
                  <InputLabel>Company</InputLabel>
                  <Input defaultValue={data.company.name} readOnly />
                  <Button>Select</Button>
                </FormControl>
                <FormControl>
                  <InputLabel>Contact person</InputLabel>
                  <Input defaultValue={data.contact.name} readOnly />
                  <Button>Select</Button>
                </FormControl>
              </Grid>
            </Grid>
            <Grid container columnGap={2}>
              <Grid>
                <FormControl>
                  <label>From date</label>
                  <DatePicker
                    defaultValue={converDate(data.agreement.from_date)}
                    onChange={(v) => setFormData({ ...formData, from_date: v })}
                  />
                </FormControl>
              </Grid>
              <Grid>
                <FormControl>
                  <label>To date</label>

                  <DatePicker
                    defaultValue={converDate(data.agreement.to_date)}
                    onChange={(v) => setFormData({ ...formData, to_date: v })}
                  />
                </FormControl>
              </Grid>
            </Grid>
            <Grid container columnGap={2}>
              <Grid>
                <FormControl>
                  <label>Offered date</label>
                  <DatePicker
                    defaultValue={converDate(data.agreement.offered_at)}
                    onChange={(v) =>
                      setFormData({ ...formData, offered_at: v })
                    }
                  />
                </FormControl>
              </Grid>
              <Grid>
                <FormControl>
                  <label>Accepted date</label>

                  <DatePicker
                    defaultValue={converDate(data.agreement.accepted_at)}
                    onChange={(v) =>
                      setFormData({ ...formData, accepted_at: v })
                    }
                  />
                </FormControl>
              </Grid>
            </Grid>
            <div>
              <Button
                onClick={() => {
                  if (props.id === 0) {
                    create();
                  } else {
                    update();
                  }
                }}
              >
                {props.id ? "Update" : "Create"}
              </Button>
            </div>
          </LocalizationProvider>
        </Box>
      </TabPanel>
      <TabPanel index={1} value={acitveTab}>
        <Button>Add product</Button>
        <Box sx={{ display: "flex" }}>
          <Box sx={{ width: "60%" }}>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell>Product 1</TableCell>
                  <TableCell>Update</TableCell>
                  <TableCell>See usage</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Product 2</TableCell>
                  <TableCell>Update</TableCell>
                  <TableCell>See usage</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Box>
          <Box>Usage</Box>
        </Box>
      </TabPanel>
      <TabPanel index={2} value={acitveTab}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell>2025-04</TableCell>
              <TableCell>Download</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>2025-03</TableCell>
              <TableCell>Download</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TabPanel>
    </div>
  );
};
